// Manual portfolio data - easily editable for adding new artwork
// This file contains all the portfolio images and can be easily updated

const portfolioData = [
  {
    id: 'artwork-1',
    title: 'Feature 1',
    medium: 'Digital Art',
    year: '2024',
    category: 'digital',
    image: `${process.env.PUBLIC_URL}/images/feature-1.png`,
    thumbnail: `${process.env.PUBLIC_URL}/images/feature-1.png`,
    caption: 'Feature 1 - A digital exploration of contemporary themes through innovative visual techniques.',
    description: 'Digital artwork exploring modern themes with experimental approaches to form and composition.',
    dimensions: 'Digital',
    tags: ['digital art', 'contemporary', 'experimental', 'form', 'composition']
  },
  {
    id: 'artwork-2',
    title: 'Feature 3',
    medium: 'Digital Art',
    year: '2024',
    category: 'digital',
    image: `${process.env.PUBLIC_URL}/images/feature-3.png`,
    thumbnail: `${process.env.PUBLIC_URL}/images/feature-3.png`,
    caption: 'Feature 3 - Another exploration in digital art, pushing the boundaries of visual expression.',
    description: 'Digital artwork that challenges traditional notions of representation and form.',
    dimensions: 'Digital',
    tags: ['digital art', 'boundaries', 'visual expression', 'representation']
  },
  {
    id: 'artwork-3',
    title: 'Hybrid',
    medium: 'Mixed Media',
    year: '2024',
    category: 'mixed',
    image: `${process.env.PUBLIC_URL}/images/hybrid.png`,
    thumbnail: `${process.env.PUBLIC_URL}/images/hybrid.png`,
    caption: 'Hybrid - A mixed media piece exploring the intersection of different artistic approaches and techniques.',
    description: 'Mixed media artwork that combines various techniques to create a unique visual language.',
    dimensions: 'Mixed Media',
    tags: ['mixed media', 'hybrid', 'techniques', 'visual language', 'intersection']
  },
  {
    id: 'artwork-4',
    title: 'Rebirth',
    medium: 'Digital Art',
    year: '2024',
    category: 'digital',
    image: `${process.env.PUBLIC_URL}/images/rebirth.png`,
    thumbnail: `${process.env.PUBLIC_URL}/images/rebirth.png`,
    caption: 'Rebirth - A digital exploration of transformation and renewal through contemporary art practices.',
    description: 'Digital artwork examining themes of transformation, renewal, and personal growth.',
    dimensions: 'Digital',
    tags: ['digital art', 'rebirth', 'transformation', 'renewal', 'growth']
  },
  {
    id: 'artwork-5',
    title: 'Self',
    medium: 'Digital Art',
    year: '2024',
    category: 'digital',
    image: `${process.env.PUBLIC_URL}/images/feature-2.png`,
    thumbnail: `${process.env.PUBLIC_URL}/images/feature-2.png`,
    caption: 'Self - A personal exploration of identity and self-expression through digital art.',
    description: 'Digital self-portrait exploring themes of identity, self-expression, and personal narrative.',
    dimensions: 'Digital',
    tags: ['digital art', 'self', 'identity', 'self-expression', 'personal']
  },
  {
    id: 'artwork-6',
    title: 'Speak None',
    medium: 'Digital Art',
    year: '2024',
    category: 'digital',
    image: `${process.env.PUBLIC_URL}/images/speaknone.png`,
    thumbnail: `${process.env.PUBLIC_URL}/images/speaknone.png`,
    caption: 'Speak None - A digital piece exploring themes of silence, communication, and expression.',
    description: 'Digital artwork examining the power of silence and non-verbal communication.',
    dimensions: 'Digital',
    tags: ['digital art', 'silence', 'communication', 'expression', 'non-verbal']
  },
  {
    id: 'artwork-7',
    title: 'Tanned',
    medium: 'Digital Art',
    year: '2024',
    category: 'digital',
    image: `${process.env.PUBLIC_URL}/images/tanned.png`,
    thumbnail: `${process.env.PUBLIC_URL}/images/tanned.png`,
    caption: 'Tanned - A digital exploration of color, texture, and visual warmth.',
    description: 'Digital artwork focusing on warm tones and textural elements to create visual depth.',
    dimensions: 'Digital',
    tags: ['digital art', 'color', 'texture', 'warmth', 'visual depth']
  },
  {
    id: 'artwork-8',
    title: 'Which',
    medium: 'Digital Art',
    year: '2024',
    category: 'digital',
    image: `${process.env.PUBLIC_URL}/images/which.png`,
    thumbnail: `${process.env.PUBLIC_URL}/images/which.png`,
    caption: 'Which - A digital piece exploring choice, decision-making, and the complexity of options.',
    description: 'Digital artwork examining themes of choice, decision-making, and the weight of options.',
    dimensions: 'Digital',
    tags: ['digital art', 'choice', 'decision', 'options', 'complexity']
  }
];

export default portfolioData;
